let queryString = window.location.search,
    urlParams = new URLSearchParams(queryString);

// This variable will hold the active focus trap instance
let activeTrap = null;

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function isScrolledIntoView(el, offset = 0) {
    let rect = el.getBoundingClientRect(),
        elemTop = rect.top,
        elemBottom = rect.bottom,
        isVisible = elemTop < window.innerHeight - offset && elemBottom >= 0;

    return isVisible;
}

function getURLParameter(url, name) {
    return (RegExp(name + '=' + '(.+?)(&|$)').exec(url)||[,null])[1];
}

// Modal window functions updated for focus-trap library
function openModal() {
    document.body.classList.add('modal--open');
    // document.getElementById('page').setAttribute("aria-hidden", "true");

    // Create and activate the focus trap
    activeTrap = focusTrap.createFocusTrap('#modal-window', {
			onDeactivate: closeModal, // Ensure closeModal is called when trap deactivates (e.g., via ESC)
			initialFocus: '#modal-window .close-modal', // Optional: focus the close button first
			allowOutsideClick: true,
		});
    activeTrap.activate();
}

function closeModal() {
    if (activeTrap) {
        // Deactivating the trap will automatically restore focus
        activeTrap.deactivate();
        activeTrap = null;
    }
    document.body.classList.remove('modal--open');
    // document.getElementById('page').removeAttribute('aria-hidden');
	$('.modal-window__content').html('');
}


// Panel functions updated for focus-trap library
function openPanel() {
    document.body.classList.add("panel--visible");
    // document.getElementById('page').setAttribute("aria-hidden", "true");

    activeTrap = focusTrap.createFocusTrap('#form-panel', {
			// Assuming your panel has id="form-panel"
			onDeactivate: closePanel,
			allowOutsideClick: true,
		});
    activeTrap.activate();
}

function closePanel() {
    if (activeTrap) {
        activeTrap.deactivate();
        activeTrap = null;
    }
    document.body.classList.remove('panel--visible');
    // document.getElementById('page').removeAttribute('aria-hidden');
}

jQuery( document ).ready(function($) {
    smoothScroll();
    navigation();
    search();
    filterForm();
    carousel();
    imageSlider();
    calloutSectionSlider();
    accordion();
    impactCounter();
    tankMixCalculator();
    openPositions();
    salesRepLocator();
    personGallery();
    testimonialFeature();
    modalInit();
    //youtubeEmbed();
});
